// lokalne tłumaczenia

import { localResources } from './resources';
import i18n from '../../packages/core/src/i18n';

// Dodaj lokalne zasoby do i18n
Object.keys(localResources).forEach((lang) => {
  if (localResources[lang] && localResources[lang].translation) {
    Object.keys(localResources[lang].translation).forEach((key) => {
      i18n.addResource(lang, 'translation', key, localResources[lang].translation[key]);
    });
  }
});

// Re-eksportujemy i18n z core
export { default } from '../../packages/core/src/i18n';
export { localResources };



